import {DebugLogger} from '../utils/debug-logger.util';

export function logTabRender(label: string, value: string | number): void {
  const start = performance.now();

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      DebugLogger.log(`${label}-${value} rendered in ${(performance.now() - start).toFixed(1)} ms`);
    });
  });
}
